import {
  ReschedulePolicyBehavior,
  ShopOnboardingCategory,
  ShopOnboardingID,
} from '@prisma/client';
import { ROUTES } from './global';
import { ShopTab } from '../routes/ShopPage';

const constructPath = (route: string, params?: Record<string, string>) => {
  if (!params) return route;
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    searchParams.set(key, value);
  });
  return `${route}?${searchParams.toString()}`;
};

export const ONBOARDING_STEPS_ROUTES: Record<ShopOnboardingID, string> = {
  [ShopOnboardingID.LOCATION]: constructPath(ROUTES.shop),
  [ShopOnboardingID.STAFF_ONBOARD]: constructPath(ROUTES.team),
  [ShopOnboardingID.PAYMENTS]: constructPath(ROUTES.payments),
  [ShopOnboardingID.BOOKING_LINK]: constructPath(ROUTES.bookingLinks),
  [ShopOnboardingID.WAIVERS]: constructPath(ROUTES.waivers),
  [ShopOnboardingID.SHOP_SETTINGS]: constructPath(ROUTES.shop, {
    tab: ShopTab.BOOKING,
  }),
  [ShopOnboardingID.BOOKING_MESSAGES]: constructPath(ROUTES.shop, {
    tab: ShopTab.CLIENT_MESSAGES,
  }),
  [ShopOnboardingID.ITEM_LIBRARY]: constructPath(ROUTES.items),
  [ShopOnboardingID.TERMINAL_READER]: constructPath(ROUTES.shop, {
    tab: ShopTab.TERMINAL,
  }),
  [ShopOnboardingID.IMPORT_DATA]: constructPath(ROUTES.import),
  [ShopOnboardingID.REVIEWS]: constructPath(ROUTES.reviews),
  [ShopOnboardingID.ADS]: constructPath(ROUTES.ads),
};

export const ONBOARDING_CATEGORY_NAMES: Record<ShopOnboardingCategory, string> =
  {
    [ShopOnboardingCategory.ACTIVATE]: 'Activate your account',
    [ShopOnboardingCategory.CONFIGURE]: 'Configure shop settings',
  };

// Names where each step's deep link lands, so the row says where it is going.
export const ONBOARDING_STEPS_LINK_LABELS: Record<ShopOnboardingID, string> = {
  [ShopOnboardingID.LOCATION]: 'Manage Shop \u203A Business',
  [ShopOnboardingID.STAFF_ONBOARD]: 'Manage Team',
  [ShopOnboardingID.PAYMENTS]: 'Payments Account',
  [ShopOnboardingID.BOOKING_LINK]: 'Booking Links',
  [ShopOnboardingID.WAIVERS]: 'Waivers',
  [ShopOnboardingID.SHOP_SETTINGS]: 'Manage Shop \u203A Booking',
  [ShopOnboardingID.BOOKING_MESSAGES]: 'Manage Shop \u203A Client Messages',
  [ShopOnboardingID.ITEM_LIBRARY]: 'Items & Gift Cards',
  [ShopOnboardingID.TERMINAL_READER]: 'Manage Shop \u203A Terminal',
  [ShopOnboardingID.IMPORT_DATA]: 'Import Data',
  [ShopOnboardingID.REVIEWS]: 'Online Reviews',
  [ShopOnboardingID.ADS]: 'Ads',
};

export const RESCHEDULE_BEHAVIOR_LABELS: Record<
  ReschedulePolicyBehavior,
  string
> = {
  DEPOSIT: 'Charge a new deposit',
  FREE: 'Always allow free reschedules',
  FLAT_FEE: 'Charge a flat reschedule fee',
  DISABLED: "Don't allow reschedules",
};

export const RESCHEDULE_BEHAVIOR_OPTIONS = Object.entries(
  RESCHEDULE_BEHAVIOR_LABELS,
).map(([value, label]) => ({
  value: value as ReschedulePolicyBehavior,
  label,
}));
